import React, { useEffect, useState, useContext, useRef } from "react";
import { Card } from 'primereact/card';
import { Skeleton } from 'primereact/skeleton';
import { useWeb3React } from "@web3-react/core";

import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';

import ContractContext from '../../ContractContext'; //Required for all dApp components using contracts

import { formatDecimals, formatCurrencyExtended, abbreviateNumber, getTokenPrice } from '../../utils';
import { miniCardHeaderStyle, miniInfoStyle, cardHeaderStyle } from "./TileStyles";

import { getGradientCardStyle } from "./TileStyles";
import rocketfiIcon from "../../imgs/rocketfi_yellow_token.png";
import BigNumber from 'bignumber.js'

const DashboardPayItForward = ({ data, getData }) => {

  const { library, account } = useWeb3React();
  const contractContext = useContext(ContractContext);
  const contracts = contractContext.contracts;
  const isWalletConnected = () => account !== null;

  const [eligible, setEligible] = useState();
  const [payItForwardData, setPayItForwardData] = useState();

  const LoadingContent = () => <Skeleton width="100%" height="35px" className="mb-2" />;
  const LoadingTitle = () => <Skeleton width="70%" height="25px" className="mb-2" />;

  const toast = useRef(null);



  const handlePayItForward = async () => {
    if (!isWalletConnected()) {
      return;
    }
    if (!contracts.payItForward) {
      return;
    }


    try {
      const transaction = contracts.payItForward.methods.payItForward().send({ from: account });

      transaction.on("transactionHash", (hash) => {
        toast.current.show({ severity: 'info', summary: 'Transaction Submitted', detail: `Transaction Hash: ${hash}. Follow the transaction on BscScan here: https://bscscan.com/tx/${hash}`, life: 3000 });
      });

      const tx = await transaction;

      toast.current.show({ severity: 'success', summary: 'Transaction Success', detail: 'The transaction has been completed successfully. You earned a Boost Pool Multiplier!', life: 3000 });

      getData();
    } catch (error) {
      console.error("Error interacting with the Pay It Forward contract:", error);
      toast.current.show({ severity: 'error', summary: 'Transaction Error', detail: `Error interacting with the Pay It Forward contract: ${error.message}`, life: 3000 });
    }
  };




  const getPayItForwardData = async () => {
    if (!contracts.payItForward) {
        //console.error("PayItForward contract not available.");
        return;
    }

    try {
        const areReflectionsAvailable = await contracts?.payItForward?.methods.areReflectionsAvailable().call();
        const isInCoolDown = await contracts?.payItForward?.methods.isInCoolDown(account).call();
        const minBalance = new BigNumber(await contracts?.payItForward?.methods.minBalance().call());
        const rocketFiBalance = new BigNumber(data?.contractData?.tokenData?.rocketFiBalance);
        const rocketTokens =  data?.contractData?.playData?.rocketTokens;
        // console.log("areReflectionsAvailable:", areReflectionsAvailable);
        // console.log("isInCoolDown:", isInCoolDown);
        // console.log("minBalance:", minBalance.toString());
        // console.log("rocketFiBalance:", rocketFiBalance.toString());
        // console.log("rocketTokens:", rocketTokens);
        const _eligible = areReflectionsAvailable && !isInCoolDown && rocketFiBalance.gte(minBalance) && parseInt(rocketTokens) === 0 ;
        // console.log("_eligible:", _eligible);
        setEligible(_eligible);
    } catch (error) {
        setEligible(false);
        console.error("Error interacting with the Pay It Forward contract:", error);
    }
    };

    useEffect(() => {
        getPayItForwardData();
        //console.log("data:", data);
    }, [data]);


  const payItForwardCardStyle = getGradientCardStyle(rocketfiIcon, 'auto, auto 140%, auto', "rgb(236, 103, 255, 0.91)", "rgba(51, 107, 187, 0.9)");


  return (
    eligible && 
    data &&
    <>
    <Card title={<div style={cardHeaderStyle}>Pay It Forward</div>} style={payItForwardCardStyle}>
        Speed up the reward pack distributions and gain a PlayPool multiplier. <br />
        <Button
        rounded
        severity="warning"
        onClick={handlePayItForward}
        size="small"
        style={{ width: '100%', justifyContent: 'center', marginTop: '10px' }}
      >
        Pay It Forward
      </Button>
      <Toast ref={toast} />
    </Card>

    </>
  );
}

export default DashboardPayItForward;
